<!--
 * @Author: 
 * @Date: 2022-03-22 12:39:30
 * @LastEditors: 
 * @LastEditTime: 2022-06-29 11:19:32
 * @FilePath: /Cup2Market/src/components/activity/panel/goods/item.vue
 * @Description: 
-->
<template>
  <GoodsCard :data="data" :coupons="coupons"></GoodsCard>
</template>

<script>
import GoodsCard from "@/components/card/GoodsCard";
export default {
  components: { GoodsCard },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    coupons: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
